import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertState } from 'interfaces/alert.model';

const initialState: AlertState = {
  type: null,
  title: null,
  bodyText: null,
  isShown: false,
  isClosed: false,
  isLogoPopUpOpen: false,
  isCategoriesPopUpOpen: false,
};

export const alertReducer = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlert: (state, action: PayloadAction<Partial<AlertState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    showAlert: (state) => {
      state.isShown = true;
    },
    hideAlert: () => {
      return { ...initialState };
    },
    closeButtonClick: (state) => {
      state.isClosed = true;
    },
    updateIsClosed: (state) => {
      state.isClosed = false;
    },
    showLogoPopUp: (state) => {
      state.isLogoPopUpOpen = true;
    },
    closeLogoPopUp: (state) => {
      state.isLogoPopUpOpen = false;
      state.isShown = false;
    },
    showCategoriesPopUp: (state) => {
      state.isCategoriesPopUpOpen = true;
    },
    closeCategoriesPopUp: (state) => {
      state.isCategoriesPopUpOpen = false;
      state.isShown = false;
    },
  },
});

export const {
  setAlert,
  showAlert,
  hideAlert,
  closeButtonClick,
  updateIsClosed,
  showLogoPopUp,
  closeLogoPopUp,
  showCategoriesPopUp,
  closeCategoriesPopUp,
} = alertReducer.actions;

export default alertReducer.reducer;
